import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { put, takeLatest, select } from 'redux-saga/effects';
import { TaskId } from 'api/models';
import { TaskAPI, TaskSourceType } from 'api/tasks';
import { removeTask } from 'data/home/slice';
import { removeTaskFromSpaceTab } from 'data/space-tabs';
import { deleteTaskSagaAction, FetchTaskActionPayload } from '../actions';
import { Task } from '../schema';
import { selectTask } from '../selectors';
import { deleteTask } from '../slice';

function* deleteTaskByIdSaga({
  payload,
}: PayloadAction<FetchTaskActionPayload>): Generator {
  const { projectId, taskId } = payload;
  const task = (yield select(selectTask(TaskId(projectId, taskId)))) as Task;

  if (task) {
    if (task.source && task.source.sourceId) {
      if (task.source.sourceType === TaskSourceType.SpaceTab) {
        yield put(
          removeTaskFromSpaceTab({
            spaceTabId: task.source.sourceId,
            taskId,
          }),
        );
      }
    }

    yield put(removeTask(taskId));
  }
  yield put(deleteTask(TaskId(projectId, taskId)));

  try {
    yield TaskAPI.deleteTask(projectId, taskId);
  } catch (error) {
    message.error('There was an error processing your request.');
  }
}

export const watchDeleteTaskByIdSaga = function* (): Generator {
  yield takeLatest(deleteTaskSagaAction.type, deleteTaskByIdSaga);
};
